module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Statement of Facts"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Statement of facts\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statement_of_facts),
      expression: "briefOfEvidence.statement_of_facts"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.statement_of_facts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "statement_of_facts", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Case Information Form"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.victim_impact_statement_taken),
      expression: "briefOfEvidence.victim_impact_statement_taken"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.victim_impact_statement_taken) ? _vm._i(_vm.briefOfEvidence.victim_impact_statement_taken, null) > -1 : (_vm.briefOfEvidence.victim_impact_statement_taken)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.victim_impact_statement_taken,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken", $$c)
        }
      }
    }
  }), _vm._v("\n                Victim impact statement to be taken?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.victim_impact_statement_taken) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.victim_impact_statement_taken_details),
      expression: "briefOfEvidence.victim_impact_statement_taken_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.victim_impact_statement_taken_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "victim_impact_statement_taken_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statements_pending),
      expression: "briefOfEvidence.statements_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.statements_pending) ? _vm._i(_vm.briefOfEvidence.statements_pending, null) > -1 : (_vm.briefOfEvidence.statements_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.statements_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "statements_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "statements_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "statements_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Witness (including expert statements) still to be taken?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.statements_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.statements_pending_details),
      expression: "briefOfEvidence.statements_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.statements_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "statements_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.vulnerable_hostile_witnesses),
      expression: "briefOfEvidence.vulnerable_hostile_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.vulnerable_hostile_witnesses) ? _vm._i(_vm.briefOfEvidence.vulnerable_hostile_witnesses, null) > -1 : (_vm.briefOfEvidence.vulnerable_hostile_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.vulnerable_hostile_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Vulnerable / hostile witnesses?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.vulnerable_hostile_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.vulnerable_hostile_witnesses_details),
      expression: "briefOfEvidence.vulnerable_hostile_witnesses_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.vulnerable_hostile_witnesses_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "vulnerable_hostile_witnesses_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.witness_refusing_statement),
      expression: "briefOfEvidence.witness_refusing_statement"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.witness_refusing_statement) ? _vm._i(_vm.briefOfEvidence.witness_refusing_statement, null) > -1 : (_vm.briefOfEvidence.witness_refusing_statement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.witness_refusing_statement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "witness_refusing_statement", $$c)
        }
      }
    }
  }), _vm._v("\n                Witnesses refusing to make statements?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.witness_refusing_statement) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.witness_refusing_statement_details),
      expression: "briefOfEvidence.witness_refusing_statement_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.witness_refusing_statement_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "witness_refusing_statement_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.problems_needs_prosecution_witnesses),
      expression: "briefOfEvidence.problems_needs_prosecution_witnesses"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.problems_needs_prosecution_witnesses) ? _vm._i(_vm.briefOfEvidence.problems_needs_prosecution_witnesses, null) > -1 : (_vm.briefOfEvidence.problems_needs_prosecution_witnesses)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.problems_needs_prosecution_witnesses,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $$c)
        }
      }
    }
  }), _vm._v("\n                Specific problems / needs of prosecution witnesses, e.g. interpreters?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.problems_needs_prosecution_witnesses) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.problems_needs_prosecution_witnesses),
      expression: "briefOfEvidence.problems_needs_prosecution_witnesses"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.problems_needs_prosecution_witnesses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "problems_needs_prosecution_witnesses", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.accused_bad_character),
      expression: "briefOfEvidence.accused_bad_character"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.accused_bad_character) ? _vm._i(_vm.briefOfEvidence.accused_bad_character, null) > -1 : (_vm.briefOfEvidence.accused_bad_character)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.accused_bad_character,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "accused_bad_character", $$c)
        }
      }
    }
  }), _vm._v("\n                History of bad character / propensity (similar fact) evidence involving accused?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.accused_bad_character) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.accused_bad_character_details),
      expression: "briefOfEvidence.accused_bad_character_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.accused_bad_character_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "accused_bad_character_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.further_persons_interviews_pending),
      expression: "briefOfEvidence.further_persons_interviews_pending"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.further_persons_interviews_pending) ? _vm._i(_vm.briefOfEvidence.further_persons_interviews_pending, null) > -1 : (_vm.briefOfEvidence.further_persons_interviews_pending)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.further_persons_interviews_pending,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending", $$c)
        }
      }
    }
  }), _vm._v("\n                Further persons (witness or suspect) to be interviewed?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.further_persons_interviews_pending) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.further_persons_interviews_pending_details),
      expression: "briefOfEvidence.further_persons_interviews_pending_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.further_persons_interviews_pending_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "further_persons_interviews_pending_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_interviews),
      expression: "briefOfEvidence.other_interviews"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_interviews) ? _vm._i(_vm.briefOfEvidence.other_interviews, null) > -1 : (_vm.briefOfEvidence.other_interviews)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_interviews,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_interviews", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_interviews", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_interviews", $$c)
        }
      }
    }
  }), _vm._v("\n                Other persons whose details do not appear on this brief who have been interviewed?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_interviews) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_interviews_details),
      expression: "briefOfEvidence.other_interviews_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_interviews_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_interviews_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.relevant_persons_pending_charges),
      expression: "briefOfEvidence.relevant_persons_pending_charges"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.relevant_persons_pending_charges) ? _vm._i(_vm.briefOfEvidence.relevant_persons_pending_charges, null) > -1 : (_vm.briefOfEvidence.relevant_persons_pending_charges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.relevant_persons_pending_charges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges", $$c)
        }
      }
    }
  }), _vm._v("\n                Other relevant persons charged or yet to be charged?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.relevant_persons_pending_charges) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.relevant_persons_pending_charges_details),
      expression: "briefOfEvidence.relevant_persons_pending_charges_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.relevant_persons_pending_charges_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "relevant_persons_pending_charges_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome),
      expression: "briefOfEvidence.other_persons_receiving_sanction_outcome"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_persons_receiving_sanction_outcome) ? _vm._i(_vm.briefOfEvidence.other_persons_receiving_sanction_outcome, null) > -1 : (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_persons_receiving_sanction_outcome,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome", $$c)
        }
      }
    }
  }), _vm._v("\n                Others receiving Infringement / Warning arising out of the same incident?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome_details),
      expression: "briefOfEvidence.other_persons_receiving_sanction_outcome_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_persons_receiving_sanction_outcome_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_persons_receiving_sanction_outcome_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.local_public_interest),
      expression: "briefOfEvidence.local_public_interest"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.local_public_interest) ? _vm._i(_vm.briefOfEvidence.local_public_interest, null) > -1 : (_vm.briefOfEvidence.local_public_interest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.local_public_interest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "local_public_interest", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "local_public_interest", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "local_public_interest", $$c)
        }
      }
    }
  }), _vm._v("\n                Matters of local / public interest?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.local_public_interest) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.local_public_interest_details),
      expression: "briefOfEvidence.local_public_interest_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.local_public_interest_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "local_public_interest_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_requests),
      expression: "briefOfEvidence.applications_orders_requests"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.applications_orders_requests) ? _vm._i(_vm.briefOfEvidence.applications_orders_requests, null) > -1 : (_vm.briefOfEvidence.applications_orders_requests)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.applications_orders_requests,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "applications_orders_requests", $$c)
        }
      }
    }
  }), _vm._v("\n                Other applications / orders on conviction requests?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.applications_orders_requests) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_requests_details),
      expression: "briefOfEvidence.applications_orders_requests_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.applications_orders_requests_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "applications_orders_requests_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_required),
      expression: "briefOfEvidence.applications_orders_required"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.applications_orders_required) ? _vm._i(_vm.briefOfEvidence.applications_orders_required, null) > -1 : (_vm.briefOfEvidence.applications_orders_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.applications_orders_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "applications_orders_required", $$c)
        }
      }
    }
  }), _vm._v("\n                Are there any other applications / orders on conviction required?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.applications_orders_required) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.applications_orders_required_details),
      expression: "briefOfEvidence.applications_orders_required_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.applications_orders_required_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "applications_orders_required_details", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_legal_matters),
      expression: "briefOfEvidence.other_legal_matters"
    }],
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "checkbox",
      "data-parsley-required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.briefOfEvidence.other_legal_matters) ? _vm._i(_vm.briefOfEvidence.other_legal_matters, null) > -1 : (_vm.briefOfEvidence.other_legal_matters)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.briefOfEvidence.other_legal_matters,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.briefOfEvidence, "other_legal_matters", $$c)
        }
      }
    }
  }), _vm._v("\n                Is there any statutory notice, DEC licence, ministerial statement or policy etc. re the matter, premise or person subject to this brief?\n                ")]), _vm._v(" "), (_vm.briefOfEvidence.other_legal_matters) ? _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Details\n                    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.briefOfEvidence.other_legal_matters_details),
      expression: "briefOfEvidence.other_legal_matters_details"
    }],
    staticClass: "form-control location_address_field",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.briefOfEvidence.other_legal_matters_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.briefOfEvidence, "other_legal_matters_details", $event.target.value)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Offences, Offenders and Records of Interview",
      "treeHeight": "yes"
    }
  }, [(_vm.boeRoiExist) ? _c('div', [(_vm.boeRoiVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "boe_record_of_interview_tree",
    attrs: {
      "id": "boe-record-of-interview-tree",
      "value": _vm.boeRoiTicked,
      "options": _vm.boeRoiOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setBoeRoiTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.boeRoiOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e(), _vm._v(" "), _vm._l((grandchild.children), function(greatgrandchild) {
          return _c('span', [(greatgrandchild.show) ? _c('span', [_vm._v("\n                                        ; "), _c('a', {
            attrs: {
              "href": greatgrandchild.hyperlink,
              "target": "_blank"
            }
          }, [_vm._v(_vm._s(greatgrandchild.label))])]) : _vm._e()])
        })], 2)
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Offences, Offenders or Records of Interview")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Witness Statements, Officer Statements, Expert Statements",
      "treeHeight": "yes"
    }
  }, [(_vm.boeOtherStatementsExist) ? _c('div', [(_vm.boeOtherStatementsVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('TreeSelect', {
    ref: "boe_other_statements_tree",
    attrs: {
      "id": "boe-other-statements-tree",
      "value": _vm.boeOtherStatementsTicked,
      "options": _vm.boeOtherStatementsOptions,
      "default-expand-level": Infinity,
      "multiple": "",
      "value-consists-of": "LEAF_PRIORITY",
      "alwaysOpen": "",
      "searchable": false
    },
    on: {
      "input": _vm.setBoeOtherStatementsTicked
    }
  })], 1)]) : _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.boeOtherStatementsOptions), function(record) {
    return _c('div', [(record.show) ? _c('span', [_c('a', {
      attrs: {
        "href": record.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(record.label))])]) : _vm._e(), _vm._v(" "), _vm._l((record.children), function(child) {
      return _c('span', [(child.show) ? _c('span', [_vm._v("\n                                ; "), _c('a', {
        attrs: {
          "href": child.hyperlink,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(child.label))])]) : _vm._e(), _vm._v(" "), _vm._l((child.children), function(grandchild) {
        return _c('span', [(grandchild.show) ? _c('span', [_vm._v("\n                                    ; "), _c('a', {
          attrs: {
            "href": grandchild.hyperlink,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(grandchild.label))])]) : _vm._e()])
      })], 2)
    })], 2)
  }), 0)])]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Witness Statements, Officer Statements or Expert Statements")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "id": "physical-artifacts-tree",
      "formCollapse": false,
      "label": "List of Exhibits, Sensitive Unused and Non-Sensitive Unused Materials",
      "treeHeight": "yes"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the list of exhibits")]), _vm._v(" "), (_vm.physicalArtifactsUsedVisibility) ? _c('div', {
    staticClass: "col-sm-10",
    attrs: {
      "class": "col-sm-10"
    }
  }, _vm._l((_vm.physicalArtifactsUsed), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the list of exhibits")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "id": 'tickbox_' + artifact.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), (artifact.ticked) ? _c('div', [_c('label', {
      staticClass: "col-sm-3"
    }, [_vm._v("Reason for sensitivity / non-disclosure")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.reason_sensitive_non_disclosable),
        expression: "artifact.reason_sensitive_non_disclosable"
      }],
      staticClass: "form-control",
      attrs: {
        "id": 'reason_' + artifact.physical_artifact_id,
        "readonly": _vm.readonlyForm
      },
      domProps: {
        "value": (artifact.reason_sensitive_non_disclosable)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(artifact, "reason_sensitive_non_disclosable", $event.target.value)
        }
      }
    })])]) : _vm._e()])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the sensitive unused list of materials")]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-10"
  }, [_vm._v("Select the objects to be included on the non-sensitive unused list of materials")]), _vm._v(" "), (_vm.physicalArtifactsNonSensitiveUnusedVisibility) ? _c('div', {
    staticClass: "col-sm-10"
  }, _vm._l((_vm.physicalArtifactsNonSensitiveUnused), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))])])
  }), 0) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No objects on the non-sensitive unused list of materials")])])])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "List of Photographic, Video and Sound Exhibits"
    }
  }, [(_vm.documentArtifactsVisibility) ? _c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.documentArtifacts), function(artifact) {
    return _c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (artifact.ticked),
        expression: "artifact.ticked"
      }],
      staticClass: "col-sm-1",
      attrs: {
        "disabled": _vm.readonlyForm,
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(artifact.ticked) ? _vm._i(artifact.ticked, null) > -1 : (artifact.ticked)
      },
      on: {
        "change": function($event) {
          var $$a = artifact.ticked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(artifact, "ticked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(artifact, "ticked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(artifact, "ticked", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": artifact.hyperlink,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(artifact.label))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 form-group document-artifact-file"
    }, [_c('div', {
      staticClass: "row"
    }, _vm._l((artifact.attachments), function(document) {
      return _c('div', [_c('label', [_vm._v(" " + _vm._s(document.name) + "\n                                "), (['png', 'jpg'].includes(document.type)) ? _c('div', [_c('img', {
        staticClass: "col-sm-4",
        attrs: {
          "src": document.file,
          "alt": "image file"
        }
      })]) : (['mp4'].includes(document.type)) ? _c('div', [_c('video', {
        attrs: {
          "width": "82",
          "height": "82",
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": document.file,
          "type": "video/mp4"
        }
      })])]) : _vm._e()])])
    }), 0)])])
  }), 0)]) : _c('span', {
    staticClass: "col-sm-10"
  }, [_vm._v("No Photographic, Video or Sound Exhibits")])]), _vm._v(" "), _c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Additional Documents"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('filefield', {
    key: _vm.legal_case.briefOfEvidenceDocumentUrl,
    ref: "brief_of_evidence_documents",
    attrs: {
      "name": "brief-of-evidence-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.legal_case.briefOfEvidenceDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566c9b95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/legal_case/brief_of_evidence.vue
// module id = 980
// module chunks = 0